import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, OperatorFunction, ReplaySubject, firstValueFrom } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

import { OidcConfig, OidcSettings } from '../../models';

@Injectable({ providedIn: 'root' })
export abstract class AuthSettingsService {
    private readonly http = inject(HttpClient);

    private readonly _authSettings = new ReplaySubject<OidcConfig>(1);
    public readonly authSettings = this._authSettings.asObservable();

    public initializeAuth(appSettingsPath = 'assets/appsettings.json'): Promise<OidcConfig> {
        return firstValueFrom(
            this.http.get<OidcSettings>(appSettingsPath).pipe(
                map(({ oidcConfig }) => {
                    const config = { ...oidcConfig, redirectUri: window.location.origin } as OidcConfig;
                    this._authSettings.next(config);
                    return config;
                }),
                catchError((e) => {
                    console.error(e);
                    throw e;
                })
            )
        );
    }

    public get<T>(operator: OperatorFunction<OidcConfig, T>): Observable<T> {
        return this.authSettings.pipe(take(1), operator);
    }
}
